/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { CredentialsReducer } from '../../data/interfaces';
import { mapAndAddKeyToKeyList } from '../../data/utils';
import {
    CREATE_API_KEYS_CREDENTIALS_REQUEST, CREATE_API_KEYS_CREDENTIALS_SUCCESS, CREATE_API_KEYS_CREDENTIALS_FAILURE,
    FETCH_API_KEYS_CREDENTIALS_REQUEST, FETCH_API_KEYS_CREDENTIALS_SUCCESS, FETCH_API_KEYS_CREDENTIALS_FAILURE,
    DELETE_API_KEYS_CREDENTIALS_REQUEST, DELETE_API_KEYS_CREDENTIALS_SUCCESS, DELETE_API_KEYS_CREDENTIALS_FAILURE,
    CredentialsAction
} from '../types/credentials';

const initialState: CredentialsReducer = {
    isKeyFetching: false,
    isKeyGenerating: false,
    isKeysFetched: false,
    isKeyDeleting: false,
    isTokenGenerating: false,
    keys: null,
    oauthToken: { accessToken: '', tokenScopes: [], validityTime: 0 },
    error: '',
}

const credentialsReducer = (state = initialState, action: CredentialsAction) => {
    switch (action.type) {
        case FETCH_API_KEYS_CREDENTIALS_REQUEST:
            return {
                ...state,
                isKeyFetching: true,
                isKeysFetched: false,
                keys: null
            }
        case FETCH_API_KEYS_CREDENTIALS_SUCCESS:
            return {
                ...state,
                isKeyFetching: false,
                isKeysFetched: true,
                keys: action.payload
            }
        case FETCH_API_KEYS_CREDENTIALS_FAILURE:
            return {
                ...state,
                isKeyFetching: false,
                isKeysFetched: true,
                error: action.payload
            }
        case CREATE_API_KEYS_CREDENTIALS_REQUEST:
            return {
                ...state,
                isKeyGenerating: true
            }
        case CREATE_API_KEYS_CREDENTIALS_SUCCESS:
            return {
                ...state,
                isKeyGenerating: false,
                isKeysFetched: true,
                keys: mapAndAddKeyToKeyList(action.payload, state.keys)
            }
        case CREATE_API_KEYS_CREDENTIALS_FAILURE:
            return {
                ...state,
                isKeyGenerating: false,
                isKeysFetched: true,
                error: action.payload
            }
        case DELETE_API_KEYS_CREDENTIALS_REQUEST:
            return {
                ...state,
                isKeyDeleting: true
            }
        case DELETE_API_KEYS_CREDENTIALS_SUCCESS:
            return {
                ...state,
                isKeyDeleting: false,
                isKeysFetched: true,
                keys: action.payload
            }
        case DELETE_API_KEYS_CREDENTIALS_FAILURE:
            return {
                ...state,
                isKeyDeleting: false,
                isKeysFetched: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export default credentialsReducer;
